<header>
  <img
    class="header__logo"
    src="/assets/img/logo.svg"
    alt="Logo banco Pichincha PERÚ"
    (click)="clickedLogo()"
  />
</header>

<main class="priv_poli_container">
  <ui-text align="center" weight="semibold" size="h4" color="blue-500" class="mb-6">
    Política de privacidad
  </ui-text>

  <ui-text size="small">
    De conformidad con lo previsto en la Ley de Protección de Datos Personales y su Reglamento, la
    presente política tiene como objetivo informar las condiciones bajo las cuales son tratados los
    datos personales de los clientes y/o usuarios del Banco Pichincha del Perú.
  </ui-text>

  <ui-text size="small">
    El contenido de este documento es estrictamente informativo, por lo que no constituye un medio
    para la recopilación de consentimientos.
  </ui-text>
  <div class="policies__list">
    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="1" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1">Definiciones</ui-text>
        <ui-text size="small"
          >Durante el desarrollo de la presente política se hará referencia a los siguientes
          conceptos:
        </ui-text>

        <ui-text color="blue-500" size="small" class="mt-4 mb-3" weight="semibold"
          >Datos personales</ui-text
        >
        <ui-text size="small">
          Información numérica, alfabética, fotográfica o de cualquier otra índole que identifica o
          hace identificable a una persona natural; tales como nombres, apellidos, documento de
          identidad, dirección domiciliaria y/o electrónica, número telefónico, imágenes en una
          fotografía, entre otra.
        </ui-text>

        <ui-text color="blue-500" size="small" weight="semibold" class="mt-4 mb-3"
          >Banco de datos</ui-text
        >
        <ui-text size="small">
          Conjunto organizado de datos personales que puede encontrarse en soportes físicos,
          digitales, magnéticos u otros.
        </ui-text>

        <ui-text color="blue-500" weight="semibold" size="small" class="mt-4 mb-3"
          >Tratamiento de datos personales</ui-text
        >
        <ui-text size="small">
          Cualquier tipo de procedimiento técnico, automatizado o manual que permite la
          recopilación, registro, organización, almacenamiento, conservación, utilización –entre
          otros– de datos personales.
        </ui-text>

        <ui-text color="blue-500" size="small" weight="semibold" class="mt-4 mb-3"
          >Titular de datos personales</ui-text
        >
        <ui-text size="small">
          Persona natural a quién corresponden los datos personales.
        </ui-text>

        <ui-text color="blue-500" weight="semibold" size="small" class="mt-4 mb-3"
          >Titular de banco de datos</ui-text
        >
        <ui-text size="small">
          Es aquel que determina la finalidad y contenido del banco de datos personales, el
          tratamiento de estos, así como las medidas de seguridad aplicables.
        </ui-text>

        <ui-text color="blue-500" weight="semibold" size="small" class="mt-4 mb-3"
          >Flujo transfronterizo de datos personales</ui-text
        >
        <ui-text size="small">
          Transferencia internacional de datos personales a un destinatario situado en un país
          distinto al país de origen de los datos personales.
        </ui-text>
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="2" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1"
          >Identidad y domicilio del Titular del Banco de Datos
        </ui-text>
        <ui-text size="small"
          >Banco Pichincha del Perú con RUC Nro. 20100105862 (en lo sucesivo, El Banco) situado en
          Av. Ricardo Palma Nro. 278 – Miraflores.</ui-text
        >
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="3" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1">Finalidades del Tratamiento</ui-text>
        <ui-text size="small"
          >Según sea el caso, los datos personales brindados a El Banco (en lo sucesivo, “Los
          Datos”) serán tratados para uno o más de los propósitos que a continuación se listan:
        </ui-text>

        <ui-text color="blue-500" size="small" weight="semibold" class="mt-5 mb-3"
          >3.1. Finalidades Principales</ui-text
        >

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small"
              >Cumplimiento de las condiciones necesarias para la prestación efectiva del producto
              contratado.
            </ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Tramitación de requerimientos y/o reclamos.</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small"
              >Captación de imágenes a través de sistemas de videovigilancia.</ui-text
            >
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">
              Uso del servicio de la aplicación APP Banco Pichincha Perú.
            </ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">
              Registro, sustento y control de las operaciones derivadas de la atención telefónica.
            </ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">
              Gestión de actividades para la prevención de lavado de activos y financiamiento del
              terrorismo.
            </ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">
              Control de las personas que visitan las instalaciones de El Banco.
            </ui-text>
          </div>
        </div>

        <div class="flex">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">
              Prospección de nuevos clientes.
            </ui-text>
          </div>
        </div>

        <ui-text color="blue-500" size="small" weight="semibold" class="mb-3 mt-5">
          3.2. Finalidades Secundarias</ui-text
        >

        <ui-text size="small" class="mb-2">
          Solo en caso el cliente y/o usuario acepte los tratamientos descritos en la sección
          “Consentimiento para el tratamiento de datos personales” que consta en la Solicitud de
          Crédito y/o en el portal Web de El Banco, “Los Datos” podrán ser utilizados para la
          promoción de sus productos y servicios; y/o ser objeto de transferencia hacia algunas de
          las empresas que conforman su grupo económico:</ui-text
        >

        <div class="flex">
          <div class="w-1/2">
            <ui-text size="small" weight="semibold" color="blue-500">Empresa</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="small" weight="semibold" color="blue-500">Dirección</ui-text>
          </div>
        </div>
        <div class="flex">
          <div class="w-1/2 flex">
            <ui-text size="tiny">Crecer Seguros S.A.</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Av. Jorge Basadre Nro. 310, San Isidro.</ui-text>
          </div>
        </div>
        <div class="flex">
          <div class="w-1/2 flex">
            <ui-text size="tiny">Diners Club Perú S.A.</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Av. Canaval y Moreyra Nro. 535, San Isidro.</ui-text>
          </div>
        </div>
        <div class="flex">
          <div class="w-1/2 flex">
            <ui-text size="tiny">Carsa</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Av. República de Panamá Nro. 3647, San Isidro.</ui-text>
          </div>
        </div>

        <ui-text size="small" class="mt-4">
          De no autorizar que “Los Datos” sean empleados para tales finalidades, el Banco solo podrá
          usarlos para la ejecución del contrato celebrado y/o el servicio requerido.
        </ui-text>
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="4" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1"
          >Servicio de APP Banco Pichincha Perú</ui-text
        >
        <ui-text size="small">
          El Banco pondrá a disposición de sus clientes la aplicación de su servicio de APP Banco
          Pichincha Perú, para cuyo uso tratará “Los Datos” y la ubicación de su dispositivo móvil
          con la finalidad de acceder a un sistema de localización de cajeros automáticos o redes de
          agencia, así como para que los clientes se comuniquen vía telefónica con El Banco a través
          de su servicio de Banca por Teléfono. Esto último deberá ser aceptado por el cliente a
          través del mensaje que aparezca en la aplicación, de este modo la llamada telefónica se
          realizará en forma automática.</ui-text
        >
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="5" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1">Mecanismos de Seguridad</ui-text>
        <ui-text size="small">
          El Banco ha implementado medidas técnicas, organizativas y legales orientadas a resguardar
          “Los Datos” y evitar su alteración, pérdida, tratamiento y/o acceso no autorizado. Tales
          medidas guardan correspondencia con la categoría de “Los Datos” y el tratamiento que sobre
          estos se efectúe. “Los Datos” serán tratados únicamente por aquellos colaboradores cuya
          intervención resulte necesaria para la prestación del producto y/o servicio contratado,
          los cuales se encuentran obligados a cumplir las medidas de seguridad antes mencionadas y
          a guardar secreto sobre la información a la que eventualmente accedan en ejercicio de sus
          funciones, inclusive una vez finalizada la relación que da lugar al tratamiento
          autorizado.
        </ui-text>
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="6" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1"
          >Almacenamiento de Datos Personales
        </ui-text>
        <ui-text size="small">
          Según la finalidad para la cual hayan sido recopilados “Los Datos”, estos serán
          conservados en cualquiera de los bancos de datos que a continuación se indican, los mismos
          que se encuentran debidamente inscritos ante la Autoridad Nacional de Protección de Datos
          Personales:</ui-text
        >
        <div class="flex mt-4 mb-1">
          <div class="w-1/2">
            <ui-text size="small" color="blue-500" weight="semibold">Código de Registro</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="small" color="blue-500" weight="semibold">Denominación</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01053</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Reclamos</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01054</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Videovigilancia</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01549</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Grabación de llamadas</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01550</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Registro de visitas</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01554</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Prospección</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01556</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Clientes</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01557</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Listas reguladas</ui-text>
          </div>
        </div>
        <div class="flex mb-1">
          <div class="w-1/2 flex">
            <ui-text size="tiny">01578</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny">Usuarios</ui-text>
          </div>
        </div>
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="7" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1">Plazo de Conservación</ui-text>
        <ui-text size="small">
          “Los Datos” serán almacenados por El Banco mientras dure la relación contractual y en
          observancia del plazo de conservación de documentos aplicable a las empresas del sistema
          financiero. Según lo dispuesto por el artículo 183° de la Ley Nro. 26702 – Ley General del
          Sistema Financiero y Sistema de Seguros, las instituciones bancarias están obligadas a
          conservar sus libros y documentos por un plazo no menor de diez años. Posteriormente, en
          tanto el cliente y/o usuario haya brindado su consentimiento, serán conservados y
          utilizados para la realización de prácticas comerciales hasta que opten por revocarlo.
        </ui-text>
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="8" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1"
          >Transferencia y Destinatarios</ui-text
        >
        <ui-text size="small">
          Para la ejecución de las finalidades listadas en el numeral 3 de la presente política, El
          Banco compartirá “Los Datos” con las empresas señaladas en el siguiente enlace: “Nuestros
          Proveedores”, las cuales proveen los servicios que a continuación se mencionan y cuya
          intervención resultará necesaria ante determinados supuestos:</ui-text
        >

        <div class="flex mb-1 mt-4">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Operaciones financieras</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Notariales</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Mensajería</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Seguridad</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Archivo y custodia de documentos</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Auditoría y consultoría</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Publicidad</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Centros de contacto telefónico</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Centrales de riesgos</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Consultoría legal</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Telecomunicaciones</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Gestión de cobranza</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Encuesta de calidad</ui-text>
          </div>
        </div>

        <div class="flex mb-1">
          <div class="bullet__cotainer">
            <ui-bullet type="square"></ui-bullet>
          </div>
          <div>
            <ui-text size="small">Plataformas tecnológicas</ui-text>
          </div>
        </div>

        <ui-text size="small" class="mt-4"
          >Adicionalmente, respecto de la información almacenada en los bancos de datos de reclamos,
          usuarios y clientes se realizará un flujo transfronterizo de información, de acuerdo con
          el siguiente detalle:</ui-text
        >

        <ui-text size="small" class="mt-4" color="blue-500" weight="semibold"
          >Destinatario:
          <ui-text size="small">Amazon Web Services INC.</ui-text>
        </ui-text>

        <ui-text size="small" color="blue-500" weight="semibold"
          >País:
          <ui-text size="small">Estados Unidos de América.</ui-text>
        </ui-text>

        <ui-text size="small" color="blue-500" weight="semibold">
          Finalidad:
          <ui-text size="small"
            >Servicio de alojamiento Web a fin de salvaguardar “Los Datos” de los usuarios
          </ui-text>
        </ui-text>

        <ui-text class="mt-4" size="small"
          >Es preciso indicar que, en virtud del Principio de Nivel de Protección adecuado, El Banco
          garantiza a los titulares de datos personales un nivel suficiente de protección sobre su
          información.</ui-text
        >
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="9" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1"
          >Derechos Asociados a la Protección de Datos Personales</ui-text
        >
        <ui-text size="small">
          El titular de datos personales podrá controlar su información mediante el ejercicio de los
          derechos que a continuación se describen:</ui-text
        >
        <div class="flex mt-4 mb-1">
          <div class="w-1/2">
            <ui-text size="small" weight="semibold" color="blue-500">Derecho</ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="small" weight="semibold" color="blue-500" align="center"
              >Plazo de Atención</ui-text
            >
          </div>
        </div>
        <div class="flex mb-1 items-center">
          <div class="w-1/2 flex">
            <ui-text size="tiny">
              <ui-text size="tiny" weight="semibold">Acceso:</ui-text> Solicitar la información que
              sobre sí mismo sea objeto de tratamiento.
            </ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny" align="center">20 días</ui-text>
          </div>
        </div>
        <div class="flex mb-1 items-center">
          <div class="w-1/2 flex">
            <ui-text size="tiny">
              <ui-text size="tiny" weight="semibold">Rectificación:</ui-text> Modificar “Los Datos”
              personales inexactos, erróneos o falsos.
            </ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny" align="center">10 días</ui-text>
          </div>
        </div>
        <div class="flex mb-1 items-center">
          <div class="w-1/2">
            <ui-text size="tiny">
              <ui-text size="tiny" weight="semibold">Cancelación:</ui-text> Eliminación de nuestra
              información de un banco de datos.
            </ui-text>
            <ui-text size="tiny">
              <ui-text size="tiny" weight="semibold">Oposición:</ui-text> Negarnos al uso de “Los
              Datos” cuando no hayamos brindado nuestro consentimiento.
            </ui-text>
            <ui-text size="tiny">
              <ui-text size="tiny" weight="semibold">Revocación:</ui-text> Impide el uso de “Los
              Datos” para las finalidades adicionales que dan lugar al tratamiento autorizado.
            </ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny" align="center">No más de 5 días </ui-text>
          </div>
        </div>
        <div class="flex items-center">
          <div class="w-1/2 flex">
            <ui-text size="tiny">
              <ui-text size="tiny" weight="semibold">Información:</ui-text> Solicitar información
              relativa a las condiciones de tratamiento.
            </ui-text>
          </div>
          <div class="w-1/2">
            <ui-text size="tiny" align="center">8 días</ui-text>
          </div>
        </div>

        <ui-text size="tiny" class="mt-4"
          >Los días se computan en hábiles y se contabilizan desde el día siguiente de la
          presentación de la comunicación.</ui-text
        >

        <ui-text class="mt-4" size="small">
          El cliente y/o usuario –o de corresponder, su representante debidamente facultado– deberá
          presentar una solicitud ante cualquiera de las oficinas que conforman la red de El Banco o
          completar los formularios puestos a su disposición en este canal. De considerar que El
          Banco no ha atendido en su integridad el requerimiento, el titular de datos personales
          podrá recurrir vía reclamación ante la Autoridad Nacional de Protección de Datos
          Personales ubicada en Calle Scipión Llona Nro. 350 – Miraflores en defensa de sus
          intereses.
        </ui-text>
      </div>
    </div>

    <div class="policies__list-item">
      <div class="mr-2">
        <ui-icon-circle label="10" background-color="dark-grayish-blue-200"></ui-icon-circle>
      </div>
      <div>
        <ui-text color="blue-500" size="h6" class="mb-3 mt-1"
          >Consecuencias de proporcionar los datos o su negativa a hacerlo</ui-text
        >
        <ui-text size="small">
          En atención al Principio de Proporcionalidad, la información a ser requerida por El Banco
          siempre resultará imprescindible para cumplir con la finalidad que ameritó la recopilación
          de “Los Datos”; en este sentido, de no proporcionarlos, El Banco no podrá prestar el
          producto y/o servicio requerido.</ui-text
        >
      </div>
    </div>
  </div>
</main>
